export default __webpack_public_path__ + "static/media/tooltip.a3cb65f9.svg";